import React from 'react';

const BigBadge = (props) => <span className="big_badge">
  <span>{props.children}</span>
</span>;

export default BigBadge;